const rolePriorities = ["USER", "MANAGER", "ADMIN"] as const;

export const getRolePriority = (role: (typeof rolePriorities)[number]) =>
  rolePriorities.indexOf(role);
